import { useEffect, useState } from "react";

export type ToastKind = "success" | "error" | "info";

export interface ToastRequest {
  kind: ToastKind;
  message: string;
}

const DURATION_MS = 5000;

const COLORS: Record<ToastKind, string> = {
  success: "rgb(0, 128, 0)",
  error: "#797777",
  info: "#D80801",
};

type Listener = (request: ToastRequest) => void;

let listener: Listener | null = null;

export function showToast(request: ToastRequest): void {
  listener?.(request);
}

export function ToastHost() {
  const [toast, setToast] = useState<(ToastRequest & { at: number }) | null>(
    null,
  );

  useEffect(() => {
    listener = (request) => {
      // `at` restarts the timer when the same message fires twice in a row,
      // which is exactly what a second wrong PIN does.
      setToast({ ...request, at: Date.now() });
    };
    return () => {
      listener = null;
    };
  }, []);

  useEffect(() => {
    if (toast === null) {
      return;
    }
    const timer = setTimeout(() => {
      setToast(null);
    }, DURATION_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [toast]);

  if (toast === null) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="safe-bottom pointer-events-none fixed inset-x-0 bottom-0 z-[100] px-2"
    >
      <div
        style={{ backgroundColor: COLORS[toast.kind] }}
        className="pointer-events-auto mb-2 flex items-center justify-between gap-2 rounded-[8px] py-3.5 pr-2 pl-4 shadow-lg"
      >
        <span className="text-14 leading-5 font-medium text-white">
          {toast.message}
        </span>
        <button
          type="button"
          aria-label="ปิด"
          onClick={() => {
            setToast(null);
          }}
          className="text-16 shrink-0 px-3 leading-5 font-medium text-white"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
